export default {
  name: 'CircleDiagram',
  props: {
    radius: {
      type: Number,
      default: 68
    },
    strokeWidth: {
      type: Number,
      default: 12
    },
    bkgCircleColor: {
      type: String,
      default: '#F3F0F6'
    },
    bkgScaleColor: {
      type: String,
      default: '#593289'
    },
    bkgPoint: {
      type: String,
      default: '#FFFFFF'
    },
    /**
     * Проценты
     */
    value: {
      type: Number,
      default: 0
    },
    showPoint: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    viewBox() {
      const sideLength = this.radius * 2
      return `0 0 ${sideLength} ${sideLength}`
    },
    circleRadius() {
      return this.radius - this.strokeWidth / 2
    },
    path() {
      return `
        M${this.radius} ${this.strokeWidth / 2}
        a ${this.circleRadius} ${this.circleRadius} 0 0 1 0 ${this.circleRadius * 2}
        a ${this.circleRadius} ${this.circleRadius} 0 0 1 0 -${this.circleRadius * 2}
      `
    },

    circumference() {
      return 2 * Math.PI * this.circleRadius
    },

    arcLenth() {
      return this.circumference / 100 * this.value
    },

    dashArray() {
      return `${this.arcLenth}, ${this.circumference}`
    },

    pathPoint() {
      const { circleRadius } = this
      const angle = (180 * this.arcLenth) / (Math.PI * circleRadius) + 90
      const angleRadians = angle * Math.PI / 180
      const centerX = circleRadius + this.strokeWidth / 2
      const centerY = circleRadius
      const x = -Math.round(circleRadius * Math.cos(angleRadians)) + centerX
      const y = -Math.round(circleRadius * Math.sin(angleRadians)) + centerY
      const pointRadius = this.strokeWidth / 2 // 1 - это border
      return `
        M${x} ${y}
        a ${pointRadius} ${pointRadius} 0 0 1 0 ${this.strokeWidth}
        a ${pointRadius} ${pointRadius} 0 0 1 0 -${this.strokeWidth}
      `
    }
  }
}
